/* LM plus (preview 21 okt 2026; v2 24 okt: maak je look af met meerdere items + kleur + maat, korting-al-verwerkt-blok, betrouwbaarheid onder afrekenen): 1) winkelwagen: bijpassende items met maat + toevoegen, 2) winkelwagen: kleur en maat wijzigen per regel. PDP-deel staat in lm-plus-pdp.js. */
(function () {
if (window.__lmPlus) return;
window.__lmPlus = true;
var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var cache = {};
function getJSON(u) {
if (!cache[u]) cache[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
return cache[u];
}
function fresh(u) { return fetch(u, { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }
function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
function optNames(p) { return (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }); }
function isSize(n) { return /^(size|maat)$/i.test(n || ''); }
function baseTitle(t) { var i = (t || '').lastIndexOf(' | '); return i > 0 ? t.slice(0, i) : null; }
function colorOf(t) { var i = (t || '').lastIndexOf(' | '); return i > 0 ? t.slice(i + 3) : ''; }
function img(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
function post(path, body) {
return fetch(root + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
.then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
}
function siblings(title) {
var b = baseTitle(title);
if (!b) return Promise.resolve([]);
return getJSON(root + 'search/suggest.json?q=' + encodeURIComponent(b) + '&resources[type]=product&resources[limit]=10')
.then(function (d) {
var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
return ps.filter(function (p) { return p.title.indexOf(b + ' | ') === 0; });
}).catch(function () { return []; });
}
/* ---------- stijl (assets/lm-plus.css) ---------- */
var me = document.currentScript;
var cssUrl = me && me.getAttribute('data-css');
if (cssUrl && !document.getElementById('lm-plus-css')) {
var lk = document.createElement('link'); lk.id = 'lm-plus-css'; lk.rel = 'stylesheet'; lk.href = cssUrl; document.head.appendChild(lk);
}
/* ---------- winkelwagen verversen ---------- */
function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
function refreshCart() {
if (onCartPage()) { location.reload(); return Promise.resolve(); }
return Promise.all([
fresh(root + 'cart.js'),
fetch(root + '?sections=cart-drawer,cart-counter', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); })
]).then(function (r) {
var cart = r[0]; cart.sections = r[1];
var d = document.querySelector('cart-drawer');
if (d && typeof d.renderContents === 'function') { d.renderContents(cart, false); }
else {
var t = document.querySelector('#CartDrawer-Body');
var n = new DOMParser().parseFromString(r[1]['cart-drawer'] || '', 'text/html').querySelector('#CartDrawer-Body');
if (t && n) t.innerHTML = n.innerHTML;
}
if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
if (typeof window.updateFreeShipping === 'function') window.updateFreeShipping();
});
}
function swap(box, newId) {
var key = box.getAttribute('data-key');
var q = parseInt(box.getAttribute('data-qty'), 10) || 1;
box.classList.add('is-busy');
/* eerst nieuwe variant toevoegen (faalt netjes als hij op is), dan oude regel weg */
return post('cart/add.js', { items: [{ id: newId, quantity: q }] })
.then(function () { return post('cart/change.js', { id: key, quantity: 0 }); })
.then(refreshCart)
.catch(function () {
box.classList.remove('is-busy');
var pnl = box.querySelector('.lm-li__panel');
if (pnl) { pnl.hidden = false; pnl.insertAdjacentHTML('beforeend', '<div class="lm-li__msg">Dit lukte niet. Probeer een andere maat.</div>'); }
});
}
/* ---------- 2. kleur en maat wijzigen per regel ---------- */
var linesBusy = false;
function enhanceLines() {
var lines = document.querySelectorAll('.cart-item[id^="CartItem-"]');
if (!lines.length || linesBusy) return;
var todo = [].filter.call(lines, function (el) { return !el.hasAttribute('data-lm-li'); });
if (!todo.length) return;
todo.forEach(function (el) { el.setAttribute('data-lm-li', '1'); });
linesBusy = true;
fresh(root + 'cart.js').then(function (cart) {
todo.forEach(function (el) {
if (el.querySelector('.lm-li')) return;
var idx = parseInt(el.id.replace('CartItem-', ''), 10) - 1;
var it = cart.items[idx];
if (!it || it.final_price === 0 || it.product_has_only_default_variant) return;
var box = document.createElement('div');
box.className = 'lm-li';
box.setAttribute('data-key', it.key);
box.setAttribute('data-qty', it.quantity);
box.setAttribute('data-variant', it.variant_id);
box.setAttribute('data-handle', it.handle);
box.setAttribute('data-title', it.product_title);
box.innerHTML = '<button type="button" class="lm-li__btn" data-lm-color hidden>Kleur wijzigen</button>' +
'<button type="button" class="lm-li__btn" data-lm-size hidden>Maat wijzigen</button>' +
'<div class="lm-li__panel" hidden></div>';
var host = el.querySelector('.cart-item__content') || el.querySelector('.cart-item__details') || el;
var err = host.querySelector('[data-line-item-error]');
if (err) host.insertBefore(box, err); else host.appendChild(box);
getJSON(root + 'products/' + it.handle + '.js').then(function (p) {
var si = optNames(p).findIndex(isSize);
if (si > -1 && p.variants.length > 1) box.querySelector('[data-lm-size]').hidden = false;
}).catch(function () {});
siblings(it.product_title).then(function (s) {
if (s.filter(function (x) { return x.available && x.handle !== it.handle; }).length) box.querySelector('[data-lm-color]').hidden = false;
});
});
}).catch(function () {}).then(function () { linesBusy = false; });
}
function sizeButtons(p, currentVariantId) {
var names = optNames(p);
var si = names.findIndex(isSize);
var cur = p.variants.filter(function (v) { return v.id === currentVariantId; })[0];
var vs = p.variants.filter(function (v) {
if (si < 0) return true;
if (!cur) return true;
for (var i = 0; i < names.length; i++) { if (i !== si && v['option' + (i + 1)] !== cur['option' + (i + 1)]) return false; }
return true;
});
return vs.map(function (v) {
var label = si > -1 ? v['option' + (si + 1)] : v.title;
var isCur = v.id === currentVariantId;
return '<button type="button" class="lm-li__opt' + (isCur ? ' is-current' : '') + '" data-lm-pick="' + v.id + '"' + (isCur ? ' aria-current="true" title="Huidige maat"' : '') + (!v.available && !isCur ? ' disabled' : '') + '>' + esc(label) + '</button>';
}).join('');
}
document.addEventListener('click', function (e) {
var t = e.target;
if (!t.closest) return;
var b = t.closest('[data-lm-size]');
if (b) {
e.preventDefault();
var box = b.closest('.lm-li'), pnl = box.querySelector('.lm-li__panel');
if (!pnl.hidden && pnl.getAttribute('data-mode') === 'size') { pnl.hidden = true; return; }
getJSON(root + 'products/' + box.getAttribute('data-handle') + '.js').then(function (p) {
pnl.setAttribute('data-mode', 'size');
pnl.innerHTML = sizeButtons(p, parseInt(box.getAttribute('data-variant'), 10));
pnl.hidden = false;
});
return;
}
var c = t.closest('[data-lm-color]');
if (c) {
e.preventDefault();
var box2 = c.closest('.lm-li'), pnl2 = box2.querySelector('.lm-li__panel');
if (!pnl2.hidden && pnl2.getAttribute('data-mode') === 'color') { pnl2.hidden = true; return; }
var own = box2.getAttribute('data-handle');
Promise.all([siblings(box2.getAttribute('data-title')), getJSON(root + 'products/' + own + '.js').catch(function () { return null; })]).then(function (r) {
var list = r[0].filter(function (x) { return x.available && x.handle !== own; });
var me = r[1];
pnl2.setAttribute('data-mode', 'color');
if (!list.length) { pnl2.innerHTML = '<div class="lm-li__hint">Geen andere kleuren op voorraad.</div>'; pnl2.hidden = false; return; }
var curTile = me ? '<button type="button" class="lm-li__col is-current" data-lm-close aria-current="true" title="Huidige kleur"><img src="' + esc(img(me.featured_image || '', 120)) + '" alt="" loading="lazy">' + esc(colorOf(me.title)) + '</button>' : '';
pnl2.innerHTML = curTile + list.map(function (x) {
var im = x.image || (x.featured_image && x.featured_image.url) || '';
return '<button type="button" class="lm-li__col" data-lm-sib="' + esc(x.handle) + '"><img src="' + esc(img(im, 120)) + '" alt="" loading="lazy">' + esc(colorOf(x.title)) + '</button>';
}).join('');
pnl2.hidden = false;
});
return;
}
var cl = t.closest('[data-lm-close]');
if (cl && cl.closest('.lm-li')) { e.preventDefault(); cl.closest('.lm-li__panel').hidden = true; return; }
var sib = t.closest('[data-lm-sib]');
if (sib) {
e.preventDefault();
var box3 = sib.closest('.lm-li'), pnl3 = box3.querySelector('.lm-li__panel');
Promise.all([
getJSON(root + 'products/' + box3.getAttribute('data-handle') + '.js'),
getJSON(root + 'products/' + sib.getAttribute('data-lm-sib') + '.js')
]).then(function (r) {
var own = r[0], np = r[1];
var oi = optNames(own).findIndex(isSize), ni = optNames(np).findIndex(isSize);
var cur = own.variants.filter(function (v) { return v.id === parseInt(box3.getAttribute('data-variant'), 10); })[0];
var size = cur && oi > -1 ? cur['option' + (oi + 1)] : null;
var match = np.variants.filter(function (v) { return v.available && (ni < 0 || !size || v['option' + (ni + 1)] === size); })[0];
if (match && (size || np.variants.length === 1)) { swap(box3, match.id); return; }
/* zelfde maat niet beschikbaar: laat de maten van de nieuwe kleur zien */
pnl3.setAttribute('data-mode', 'size');
pnl3.innerHTML = '<div class="lm-li__hint">' + esc(colorOf(np.title)) + (size ? ' is niet meer in maat ' + esc(size) + '. Kies een maat:' : ': kies een maat') + '</div>' + sizeButtons(np, -1);
});
return;
}
var pick = t.closest('[data-lm-pick]');
if (pick && pick.closest('.lm-li')) {
e.preventDefault();
if (pick.classList.contains('is-current')) { pick.closest('.lm-li__panel').hidden = true; return; }
swap(pick.closest('.lm-li'), parseInt(pick.getAttribute('data-lm-pick'), 10));
}
});
/* ---------- 1. maak je look af: meerdere items, kleur + maat (v2 24 okt) ---------- */
var upBusy = false;
var FALLBACK = ['bag-alanna-black', 'bag-alanna-beige'];
var UP_MAX = 6;
function okP(p, inCart) { return p && p.available && !inCart[p.id] && p.price > 0 && !/^set\b/i.test(p.title) && !/giftcard|cadeau/i.test(p.title); }
/* v2.3 (25 okt): maak je look af = aanvullend kledingstuk. Top in de mand -> eerst onderstukken; onderstuk -> eerst tops;
   jurk/jumpsuit -> eerst jassen/blazers en accessoires. Te weinig passende aanbevelingen? Aanvullen uit de categoriecollectie. */
function catOf(t) {
t = ' ' + String(t || '').toLowerCase() + ' ';
if (/\b(broek|pant|pants|trouser|trousers|rok|skirt|short|shorts|skort|jeans|legging)\b/.test(t)) return 'bottom';
if (/\b(jurk|dress|jumpsuit|playsuit)\b/.test(t)) return 'dress';
if (/\b(jacket|blazer|jas|coat|gilet|cardigan|vest)\b/.test(t)) return 'outer';
if (/\b(bag|tas|riem|belt|sjaal|scarf)\b/.test(t)) return 'acc';
if (/\b(top|blouse|t-shirt|tshirt|shirt|sweater|pull|trui|hoodie|body|longsleeve)\b/.test(t)) return 'top';
return 'other';
}
function prefOrder(cart) {
var has = {};
cart.items.forEach(function (i) { has[catOf(i.product_title)] = 1; });
if (has.dress) return ['outer', 'acc'];
if ((has.top || has.outer) && !has.bottom) return has.outer && !has.top ? ['bottom', 'top', 'acc'] : ['bottom', 'outer', 'acc'];
if (has.bottom && !has.top && !has.outer) return ['top', 'outer', 'acc'];
return ['outer', 'acc', 'bottom', 'top'];
}
var CAT_COL = { bottom: 'broeken', top: 'tops', outer: 'jackets' };
function pickUpsell(cart) {
var inCart = {}, seen = {}, out = [], models = {};
/* v2.2 (25 okt): geen ander kleur van hetzelfde model als 'maak je look af', en elk model maar 1x */
function mk(t) { return String(baseTitle(t || '') || t || '').toLowerCase().trim(); }
cart.items.forEach(function (i) { inCart[i.product_id] = 1; models[mk(i.product_title)] = 1; });
var pref = prefOrder(cart), POOL = 18;
function rank(p) { var k = pref.indexOf(catOf(p.title)); return k < 0 ? 9 : k; }
function good() { return out.filter(function (p) { return rank(p) < 9 && rank(p) < pref.length - 1; }).length; }
var pids = [];
cart.items.filter(function (i) { return i.final_price > 0; }).forEach(function (i) { if (pids.indexOf(i.product_id) < 0) pids.push(i.product_id); });
function take(list) { (list || []).forEach(function (p) { if (out.length < POOL && okP(p, inCart) && !seen[p.id] && !models[mk(p.title)]) { seen[p.id] = 1; models[mk(p.title)] = 1; out.push(p); } }); }
var chain = Promise.resolve();
pids.slice(0, 3).forEach(function (pid) {
chain = chain.then(function () {
return getJSON(root + 'recommendations/products.json?product_id=' + pid + '&intent=complementary&limit=10').then(function (d) { take(d.products); }).catch(function () {});
});
});
pids.slice(0, 2).forEach(function (pid) {
chain = chain.then(function () {
if (good() >= 3) return;
return getJSON(root + 'recommendations/products.json?product_id=' + pid + '&intent=related&limit=10').then(function (d) { take(d.products); }).catch(function () {});
});
});
chain = chain.then(function () {
var col = CAT_COL[pref[0]];
if (!col || good() >= 3) return;
return fetch(root + 'collections/' + col + '?section_id=lm-strip', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
var hs = [], re = /\/products\/([a-z0-9\-]+)/g, m;
while ((m = re.exec(h)) && hs.length < 8) { if (hs.indexOf(m[1]) < 0) hs.push(m[1]); }
return Promise.all(hs.map(function (x) { return getJSON(root + 'products/' + x + '.js').catch(function () { return null; }); })).then(function (ps) { take(ps.filter(Boolean)); });
}).catch(function () {});
});
FALLBACK.forEach(function (h) {
chain = chain.then(function () {
if (out.length >= 2) return;
return getJSON(root + 'products/' + h + '.js').then(function (p) { take([p]); }).catch(function () {});
});
});
return chain.then(function () {
return out.map(function (p, i) { return [rank(p), i, p]; }).sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; }).map(function (x) { return x[2]; }).slice(0, UP_MAX);
});
}
function upCard(p) {
var names = optNames(p), si = names.findIndex(isSize);
var single = p.variants.length === 1 || si < 0;
var im = p.featured_image || (p.images && p.images[0]) || '';
if (im && typeof im === 'object') im = im.src || im.url || '';
var name = baseTitle(p.title) || p.title, col = colorOf(p.title);
var url = p.url || ('/products/' + p.handle);
var sizes;
if (single) {
var av = p.variants.filter(function (v) { return v.available; })[0];
sizes = '<button type="button" class="lm-up__s lm-up__s--one" data-lm-up-v="' + (av ? av.id : '') + '"' + (av ? '' : ' disabled') + '>Toevoegen +</button>';
} else {
sizes = p.variants.map(function (v) {
return '<button type="button" class="lm-up__s" data-lm-up-v="' + v.id + '"' + (v.available ? '' : ' disabled') + ' aria-label="Maat ' + esc(v['option' + (si + 1)]) + ' toevoegen">' + esc(v['option' + (si + 1)]) + '</button>';
}).join('');
}
return '<div class="lm-up__card" data-lm-up-card data-handle="' + esc(p.handle) + '" data-title="' + esc(p.title) + '">' +
'<a class="lm-up__media" href="' + esc(url) + '"><img class="lm-up__img" src="' + esc(img(im, 360)) + '" alt="' + esc(name) + '" loading="lazy"></a>' +
'<a class="lm-up__t" href="' + esc(url) + '">' + esc(name) + '</a>' +
'<div class="lm-up__meta"><span class="lm-up__c">' + esc(col) + '</span><span class="lm-up__p">' + money(p.price) + '</span></div>' +
'<div class="lm-up__cols" data-lm-up-cols hidden></div>' +
'<div class="lm-up__sizes">' + sizes + '</div>' +
'</div>';
}
function upColors(card) {
var box = card.querySelector('[data-lm-up-cols]');
if (!box || box.getAttribute('data-done')) return;
box.setAttribute('data-done', '1');
var own = card.getAttribute('data-handle');
siblings(card.getAttribute('data-title')).then(function (list) {
list = list.filter(function (x) { return x.available; });
if (list.length < 2) return;
box.innerHTML = list.slice(0, 6).map(function (x) {
var im2 = x.image || (x.featured_image && (x.featured_image.url || x.featured_image)) || '';
return '<button type="button" class="lm-up__col' + (x.handle === own ? ' is-on' : '') + '" data-lm-up-col="' + esc(x.handle) + '" title="' + esc(colorOf(x.title)) + '" aria-label="Kleur ' + esc(colorOf(x.title)) + '"><img src="' + esc(img(im2, 80)) + '" alt=""></button>';
}).join('');
box.hidden = false;
}).catch(function () {});
}
function upsell() {
var host = document.querySelector('#CartDrawer-Body #CartDrawer-CartItems');
if (!host || upBusy) return;
if (host.hasAttribute('data-lm-up-done')) return;
host.setAttribute('data-lm-up-done', '1');
upBusy = true;
fresh(root + 'cart.js').then(function (cart) {
if (!cart.items.length) return [];
return pickUpsell(cart);
}).then(function (list) {
var h = document.querySelector('#CartDrawer-Body #CartDrawer-CartItems');
if (!list || !list.length || !h || h.querySelector('[data-lm-up]')) return;
h.insertAdjacentHTML('beforeend', '<div class="lm-up" data-lm-up><div class="lm-up__k">Maak je look af</div><div class="lm-up__track">' + list.map(upCard).join('') + '</div><div class="lm-up__hint">Kies je maat om toe te voegen</div></div>');
[].forEach.call(h.querySelectorAll('[data-lm-up-card]'), upColors);
}).catch(function () {}).then(function () { upBusy = false; });
}
document.addEventListener('click', function (e) {
var t = e.target;
if (!t.closest) return;
var c = t.closest('[data-lm-up-col]');
if (c) {
e.preventDefault();
if (c.classList.contains('is-on')) return;
var card = c.closest('[data-lm-up-card]');
card.classList.add('is-busy');
getJSON(root + 'products/' + c.getAttribute('data-lm-up-col') + '.js').then(function (p) {
var tmp = document.createElement('div'); tmp.innerHTML = upCard(p);
var nc = tmp.firstChild;
var cols = card.querySelector('[data-lm-up-cols]');
[].forEach.call(cols.querySelectorAll('.lm-up__col'), function (b) { b.classList.toggle('is-on', b === c); });
nc.replaceChild(cols, nc.querySelector('[data-lm-up-cols]'));
card.parentNode.replaceChild(nc, card);
if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'lm_cart_upsell_color' });
}).catch(function () { card.classList.remove('is-busy'); });
return;
}
var s = t.closest('[data-lm-up-v]');
if (s) {
e.preventDefault();
var id = parseInt(s.getAttribute('data-lm-up-v'), 10);
if (!id) return;
var card2 = s.closest('[data-lm-up-card]');
card2.classList.add('is-busy');
try { (window.Shopify && Shopify.analytics && Shopify.analytics.publish) && Shopify.analytics.publish('lm_cart_upsell_add', { variant_id: id }); } catch (er) {}
if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'lm_cart_upsell_add', variant_id: id });
post('cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(refreshCart).catch(function () { card2.classList.remove('is-busy'); });
}
});
/* ---------- 3. korting al verwerkt + betrouwbaarheid onder afrekenen (24 okt) ---------- */
var sumBusy = false, sumKey = '';
function summary() {
var sum = document.querySelector('#CartDrawer-FormSummary #cart-summary, cart-drawer #cart-summary');
if (!sum) return;
if (!sum.parentNode.querySelector('[data-lm-trust]')) {
var act = sum.querySelector('.cart-drawer__action-buttons');
if (act) act.insertAdjacentHTML('afterend', '<div class="lm-trust" data-lm-trust><span class="lm-trust__stars" aria-hidden="true">★★★★★</span><b>Uitstekend</b> · 4,8 · beoordeeld door klanten<span class="lm-trust__usp">Ruim 65.000 klanten shopten al bij Lofty Manner</span></div>');
}
if (sumBusy || sum.hasAttribute('data-lm-sum')) return;
sum.setAttribute('data-lm-sum', '1');
sumBusy = true;
fresh(root + 'cart.js').then(function (cart) {
if (!cart.items.length) return null;
return Promise.all(cart.items.map(function (it) {
return getJSON(root + 'products/' + it.handle + '.js').then(function (p) {
var v = p.variants.filter(function (x) { return x.id === it.variant_id; })[0];
var unit = Math.max(it.original_price, (v && v.compare_at_price) || 0);
return unit * it.quantity;
}).catch(function () { return it.original_line_price; });
})).then(function (orig) {
var before = orig.reduce(function (a, b) { return a + b; }, 0);
return { before: before, total: cart.total_price, save: before - cart.total_price };
});
}).then(function (r) {
var s2 = document.querySelector('cart-drawer #cart-summary');
if (!r || !s2 || r.save < 100) return;
if (s2.querySelector('[data-lm-disc]')) return;
s2.insertAdjacentHTML('afterbegin', '<div class="lm-disc" data-lm-disc><div class="lm-disc__box">Goed nieuws! Je korting is al verwerkt</div>' +
'<div class="lm-disc__row"><span>Subtotaal</span><span>' + money(r.before) + '</span></div>' +
'<div class="lm-disc__row lm-disc__row--save"><span>Korting</span><span>-' + money(r.save) + '</span></div></div>');
s2.classList.add('lm-has-disc');
var lab = s2.querySelector('.cart-drawer__summary-content > span'); if (lab) lab.textContent = 'Totaal';
}).catch(function () {}).then(function () { sumBusy = false; });
}
/* ---------- starten en bij elke herbouw opnieuw ---------- */
var tmr = null;
/* v2.5 (25 okt): cadeau-kaart (Riem Yuna) terugzetten als die na een herbouw van de lade wegvalt */
var gicAt = 0;
function gift() {
var w = window.tlGiftInCartWidget, f = document.querySelector('cart-drawer #CartDrawer-Form');
if (!w || typeof w.renderGICWidget !== 'function' || !f) return;
if (!f.querySelector('.cart-item, .cart-drawer__items > *')) return;
if (document.querySelector('cart-drawer .salepify-gic__gic-container')) return;
if (Date.now() - gicAt < 1500) return;
gicAt = Date.now();
try { w.renderGICWidget(); } catch (e) {}
}
/* v2.6 (26 okt, teamfeedback): maak je look af toont hele kaarten (geen halve) met pijlen; geen kleurbolletjes in de winkelmand */
function upArrows() {
var u = document.querySelector('cart-drawer [data-lm-up]');
if (!u || u.querySelector('.lm-up__nav')) return;
var tr = u.querySelector('.lm-up__track'); if (!tr) return;
var k = u.querySelector('.lm-up__k'); if (!k) return;
var nav = document.createElement('div'); nav.className = 'lm-up__nav';
nav.innerHTML = '<button type="button" class="lm-up__arr" data-d="-1" aria-label="Vorige">\u2190</button><button type="button" class="lm-up__arr" data-d="1" aria-label="Volgende">\u2192</button>';
k.appendChild(nav);
function upd() { var a = nav.children; a[0].disabled = tr.scrollLeft < 4; a[1].disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4; nav.hidden = tr.scrollWidth <= tr.clientWidth + 4; }
nav.addEventListener('click', function (e) { var b = e.target.closest('.lm-up__arr'); if (!b) return; e.preventDefault(); tr.scrollBy({ left: (+b.getAttribute('data-d')) * tr.clientWidth, behavior: 'smooth' }); });
tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
setTimeout(upd, 60);
}
/* v2.7 (26 okt, teamfeedback): zoeken alleen producten; sorteerlabels; filterknop boven */
function searchForms() {
document.querySelectorAll('form[action$="/search"]').forEach(function (f) {
if (f.querySelector('input[name="type"]')) return;
var i = document.createElement('input'); i.type = 'hidden'; i.name = 'type'; i.value = 'product'; f.appendChild(i);
});
if (/\/search$/.test(location.pathname)) {
document.querySelectorAll('main a[href*="/pages/"], main a[href*="/blogs/"]').forEach(function (a) {
var cr = a.closest('.card-result'); var it = cr ? (cr.parentElement && cr.parentElement.parentElement && cr.parentElement.parentElement.classList.contains('collection__grid') ? cr.parentElement : cr) : a.closest('li, .grid__item, article'); if (it && !it.closest('header, footer, .lm-ft')) it.style.display = 'none';
});
}
}
var SORT = { 'manual': 'Relevant', 'best-selling': 'Bestsellers', 'title-ascending': 'Alfabetisch A-Z', 'title-descending': 'Alfabetisch Z-A', 'price-ascending': 'Prijs oplopend', 'price-descending': 'Prijs aflopend', 'created-descending': 'Nieuwste', 'created-ascending': 'Oudste' };
var SORT_ORDER = ['manual', 'most-relevant', 'created-descending', 'best-selling', 'price-ascending', 'price-descending', 'title-ascending', 'title-descending', 'created-ascending'];
function sortLabels() {
document.querySelectorAll('custom-select[data-dropdown-id*="Sort"], .facets__custom-select').forEach(function (cs) {
if (cs.getAttribute('data-lm-sort')) return;
var ul = cs.querySelector('.js-list-options'); if (!ul) return;
var hasManual = !!ul.querySelector('[data-value="manual"]');
ul.querySelectorAll('.js-btn-option').forEach(function (b) {
var v = b.getAttribute('data-value');
if (v === 'most-relevant' && hasManual) { b.closest('li').style.display = 'none'; return; }
if (v === 'most-relevant') b.textContent = 'Relevant';
if (SORT[v]) b.textContent = SORT[v];
});
var lis = [].slice.call(ul.children);
lis.sort(function (a, b) { var x = a.querySelector('[data-value]'), y = b.querySelector('[data-value]'); return SORT_ORDER.indexOf(x && x.getAttribute('data-value')) - SORT_ORDER.indexOf(y && y.getAttribute('data-value')); }).forEach(function (li) { ul.appendChild(li); });
var cur = cs.getAttribute('data-value'), btn = cs.querySelector('.custom-select__btn');
/* LM 27 okt (feedback Pim): knop beschrijft de actie; keuze alleen tonen als die afwijkt van de standaard */
if (btn) btn.textContent = (!cur || cur === 'manual' || cur === 'most-relevant') ? 'Sorteren' : 'Sorteren: ' + (SORT[cur] || '');
cs.setAttribute('data-lm-sort', '1');
});
document.querySelectorAll('.facets__button-filters').forEach(function (fb) {
var w = document.createTreeWalker(fb, NodeFilter.SHOW_TEXT), n;
while ((n = w.nextNode())) { if (/^\s*Filters\s*$/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace('Filters', 'Filteren'); }
});
document.querySelectorAll('select[name="sort_by"]').forEach(function (sel) {
[].forEach.call(sel.options, function (o) { if (SORT[o.value]) o.text = SORT[o.value]; if (o.value === 'most-relevant') o.text = 'Relevant'; });
});
}
function locText() {
document.querySelectorAll('.country-drawer p, .drawer p').forEach(function (p) {
if (p.getAttribute('data-lm-loc')) return;
if (/nauwkeurig te zijn met de plaats waar je bladert/.test(p.textContent)) { p.textContent = 'Kies je land en taal. Zo zie je de juiste prijzen en verzendopties.'; p.setAttribute('data-lm-loc', '1'); }
});
}
function run() { tmr = null; enhanceLines(); upsell(); summary(); gift(); upArrows(); searchForms(); sortLabels(); locText(); }
function soon() { if (!tmr) tmr = setTimeout(run, 200); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
})();
/* v2.4 (25 okt): tik op 'Kies je maat' zonder maat: maten lichten op + korte melding (eerst gebeurde er niets) */
(function () {
var st = document.createElement('style');
st.textContent = '.lm-need-size .product-option__label{border-color:#5c2230 !important;box-shadow:0 0 0 1px #5c2230;animation:lmNudge .35s 2}.lm-need-msg{display:block;width:100%;margin:.8rem 0 0;font-size:1.2rem;letter-spacing:.06em;color:#5c2230}@keyframes lmNudge{0%,100%{transform:translateX(0)}25%{transform:translateX(-3px)}75%{transform:translateX(3px)}}';
document.head.appendChild(st);
var lang = (document.documentElement.lang || 'nl').slice(0, 2);
var MSG = { nl: 'Kies eerst je maat', en: 'Please choose your size first', fr: "Choisissez d'abord votre taille" }[lang] || 'Kies eerst je maat';
document.addEventListener('click', function (e) {
var b = e.target.closest && e.target.closest('button[name="add"].is-choose-size');
if (!b) return;
var sec = b.closest('section');
var fs = (sec && sec.querySelector('fieldset[data-option-name="Size"]')) || document.querySelector('fieldset[data-option-name="Size"]');
if (!fs) return;
e.preventDefault(); e.stopPropagation();
fs.classList.remove('lm-need-size'); void fs.offsetWidth; fs.classList.add('lm-need-size');
if (!fs.querySelector('.lm-need-msg')) { var m = document.createElement('span'); m.className = 'lm-need-msg'; m.setAttribute('role', 'alert'); m.textContent = MSG; fs.appendChild(m); }
var r = fs.getBoundingClientRect();
if (r.top < 90 || r.bottom > window.innerHeight - 90) fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
if (window.dataLayer) window.dataLayer.push({ event: 'lm_pdp_kies_maat_tik' });
setTimeout(function () { fs.classList.remove('lm-need-size'); }, 1600);
}, true);
document.addEventListener('change', function (e) {
var fs = e.target.closest && e.target.closest('fieldset[data-option-name="Size"]');
if (!fs) return;
var m = fs.querySelector('.lm-need-msg'); if (m) m.remove();
fs.classList.remove('lm-need-size');
}, true);
})();

/* v2.8 (27 okt): knop in filtervenster toont aantal resultaten ("Toon 23 producten") */
(function () {
if (!document.querySelector('.collection-facets, .facets')) return;
function upd() {
  var c = document.querySelector('.product-count-of-all');
  if (!c) return;
  var n = parseInt(c.textContent.replace(/\D/g, ''), 10);
  if (isNaN(n)) return;
  var t = n === 1 ? 'Toon 1 product' : 'Toon ' + n + ' producten';
  document.querySelectorAll('button.button.js-btn-close-drawer').forEach(function (b) {
    if (!b.closest('.collection-facets, .facets, [class*="facet"]')) return;
    if (b.textContent.trim() !== t) b.textContent = t;
  });
}
var q;
new MutationObserver(function () { clearTimeout(q); q = setTimeout(upd, 150); }).observe(document.documentElement, { childList: true, subtree: true });
document.addEventListener('DOMContentLoaded', upd);
upd();
})();

/* v2.8 (27 okt, LM): eigen zwevende pil onderin met Filters en Sorteren zodra de filterbalk uit beeld is */
(function () {
var bar = document.querySelector('.sticky-filters');
if (!bar) return;
var pill = document.createElement('div');
pill.className = 'lm-fpill';
pill.innerHTML = '<button type="button" class="lm-fpill__b" data-lm-f="filters">Filteren<span class="lm-fpill__n" hidden></span></button><button type="button" class="lm-fpill__b" data-lm-f="sort">Sorteren</button><div class="lm-fpill__menu" role="listbox"></div>';
document.body.appendChild(pill);
var menu = pill.querySelector('.lm-fpill__menu'), nEl = pill.querySelector('.lm-fpill__n');
function opts() { return Array.prototype.filter.call(bar.querySelectorAll('.custom-select__option'), function (o) { return o.offsetParent !== null || getComputedStyle(o).display !== 'none'; }); }
function cur() { var b = bar.querySelector('.facets__sorting button, .custom-select__btn'); var t = b ? b.textContent.trim() : ''; t = t.replace(/^Sorteren:\s*/, ''); return (t === 'Sorteren' || !t) ? 'Relevant' : t; }
function buildMenu() {
  var c = cur(), seen = {}; menu.innerHTML = '';
  opts().forEach(function (o) {
    var t = o.textContent.trim(); if (!t || seen[t]) return; seen[t] = 1;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'lm-fpill__o' + (t === c ? ' is-cur' : ''); b.textContent = t;
    b.addEventListener('click', function () { pill.classList.remove('is-sort'); o.click(); });
    menu.appendChild(b);
  });
}
function count() { var n = bar.querySelectorAll('input[type="checkbox"]:checked').length; nEl.hidden = !n; nEl.textContent = n; }
pill.addEventListener('click', function (e) {
  var b = e.target.closest('[data-lm-f]'); if (!b) return;
  if (b.getAttribute('data-lm-f') === 'filters') {
    pill.classList.remove('is-sort');
    var s = bar.querySelector('.facets__button-filters, summary.drawer__button'); if (s) s.click();
    if (window.dataLayer) window.dataLayer.push({ event: 'lm_filterpil_klik', label: 'filters' });
  } else {
    if (!pill.classList.contains('is-sort')) buildMenu();
    pill.classList.toggle('is-sort');
    if (window.dataLayer) window.dataLayer.push({ event: 'lm_filterpil_klik', label: 'sorteren' });
  }
});
document.addEventListener('click', function (e) { if (!e.target.closest('.lm-fpill')) pill.classList.remove('is-sort'); });
var tick = false;
function check() {
  tick = false;
  var on = bar.getBoundingClientRect().bottom < -40;
  if (!on) pill.classList.remove('is-sort');
  pill.classList.toggle('is-on', on);
  count();
}
window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
check();
})();
